<template>
  <div class="chart chart-move" style="height: 90%;">
    <!-- <v-layout v-if="editMode" class="chart-tool" >
      <v-flex row >
        <v-spacer></v-spacer>
        <v-btn flat icon dark slot="activator" v-scroll-to="'#down'" @click="$emit('duplicate-chart', slice)">
          <v-tooltip bottom>
            <v-icon small slot="activator">file_copy</v-icon>
            <span>Duplicate Chart</span>
          </v-tooltip>
        </v-btn>
        <v-btn flat icon dark slot="activator" @click="$emit('edit-chart', chartId)">
          <v-tooltip bottom>
            <v-icon small slot="activator">build</v-icon>
            <span>Edit Chart</span>
          </v-tooltip>
        </v-btn>
        <v-btn flat icon dark slot="activator" @click="$emit('deleteChart', chartId)">
          <v-tooltip bottom>
            <v-icon small slot="activator">remove_circle_outline</v-icon>
            <span>Delete Chart</span>
          </v-tooltip>
        </v-btn>
      </v-flex>
    </v-layout> -->
    <v-layout v-if="editMode" class="chart-tool" >
      <v-spacer />
      <v-menu
        transition="slide-y-transition"
        offset-y
        :close-on-content-click="false"
      >
          <template v-slot:activator="{ on }">
            <v-btn dark icon v-on="on" style="outline: none;" @click="action">
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-tile @click="$emit('duplicate-chart', slice)" v-scroll-to="'#down'">
              <v-icon size="16" style="color: #757575;">file_copy</v-icon>
              <v-list-tile-title style=" margin-left: 5px; color: #757575;">Duplicate</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$emit('edit-chart', chartId)" >
              <v-icon size="16" style="color: #757575;">build</v-icon>
              <v-list-tile-title  style=" margin-left: 5px; color: #757575;">Edit</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$emit('deleteChart', chartId)" >
              <v-icon size="16" style="color: #757575;">remove_circle_outline</v-icon>
              <v-list-tile-title  style=" margin-left: 5px; color: #757575;">Delete</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
    </v-layout>
    <v-layout v-else-if="previewMode === true" mx-0 my-1>
    </v-layout>
    <v-layout v-else class="extand-chart" >
      <v-flex row >
        <v-spacer></v-spacer>
        <v-btn
          flat
          icon
          dark
          style="outline: none;"
          slot="activator"
          class="btn-zoom-chart"
          @click="$emit('full-chart', chartId)"
        >
          <v-tooltip bottom>
            <v-icon slot="activator">zoom_in</v-icon>
            <span>Full Chart</span>
          </v-tooltip>
        </v-btn>
      </v-flex>
    </v-layout>
    <!-- <p v-if="host !== ''"><font size="3" color="#f0ffff" style="margin-top: 50px;">{{host}}</font><sup><font size="2" color="#C17F3F" style="margin-top: 50px;"> BETA</font></sup></p> -->
    <p v-if="host"><font size="3" color="#f0ffff" style="margin-top: 50px;">{{host}}</font></p>
    <v-chart
      @click="handleChartClick"
      ref="options"
      @init="initChart"
      :init-Options="initOptions"
      :options="options"
      :autoresize="true"
      :style="{height, width}"
      @mouseover="ipLookup"
    ></v-chart>

  </div>
</template>

<script>
import ECharts from 'vue-echarts/components/ECharts'
import axios from 'axios'
import echarts from 'echarts'

const animationDuration = 6000

export default {
  name: 'y-bar',
  components: {
    'v-chart': ECharts
  },
  props: {
    text: {
      type: String
    },
    user_index: {
      type: String
    },
    user_inst: {
      type: String
    },
    startTime: {
      type: [String, Number]
    },
    endTime: {
      type: [String, Number]
    },
    stores: {
      type: Array
    },
    subFilter: {
      type: String
    },
    valid: {
      type: Boolean
    },
    chartId: {
      type: String
    },
    chartName: {
      type: String,
      default: 'Untitle'
    },
    width: {
      type: [String, Number],
      default: '100%'
    },
    height: {
      type: [String, Number],
      default: '120%'
    },
    topLimit: {
      type: Number,
      default: 10
    },
    field: {
      type: String
    },
    fieldsum: {
      type: String,
      default: ''
    },
    orderby: {
      type: String,
      default: '_count'
    },
    editMode: {
      type: Boolean,
      default: false
    },
    slice: {
      type: [Object]
    },
    index_now: {
      type: String
    },
    previewMode: {
      type: Boolean,
      default: false
    },
    reloadchart: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      x: [],
      y: [],
      newtime: '',
      time: '',
      times: '',
      initOptions: { renderer: 'canvas' },
      options: {},
      sub: '',
      host: ''
    }
  },
  async created () {
    if (!this.user_index) {
      this.user_index = this.index_now
    }
  },
  async mounted () {
    await this.initChart()
    await this.beforeload()
  },
  methods: {
    async ipLookup (ip) {
      let response
      if (ip.name.match(/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/)) {
        response = await axios.post(apiUrl + '/api/status/nslookup', {
          ip: ip.name
        })
      } else {}
      this.host = response.data.host
    },
    async initChart () {
      this.$refs.options.showLoading({
        color: '#4ea397',
        maskColor: 'transparent',
        textColor: '#ccc'
      })
      if (this.subFilter !== '*' && this.text !== '') {
        this.sub = ''
        this.sub = `${this.subFilter} AND ${this.text}`
      } else if (this.subFilter !== '*') {
        this.sub = ''
        this.sub = `${this.subFilter}`
      } else {
      }
      let response = await axios.post(apiUrl + '/api/query/prop', {
        start: this.startTime,
        end: this.endTime,
        instance: this.user_inst,
        index: this.user_index,
        field: this.field,
        fieldsum: this.fieldsum,
        orderby: this.orderby,
        stores: this.stores,
        sub: this.sub,
        limit: this.topLimit,
        text: this.text
      })
      // console.log(response)
      this.$refs.options.hideLoading()
      // if (response.data.msg) {
      //   this.options = {
      //     title: {
      //       show: true,
      //       text: this.chartName,
      //       textStyle: {
      //         color: '#ccc',
      //         fontFamily: 'Avenir, Helvetica, Arial, sans-serif'
      //       }
      //     },
      //     backgroundColor: 'transparent',
      //     graphic: {
      //       type: 'text',
      //       left: 'center',
      //       top: 'middle',
      //       style: {
      //         text: 'Request time out.',
      //         font: 'bolder 16px Avenir, Helvetica, Arial, sans-serif',
      //         fill: '#ccc'
      //       }
      //     },
      //     series: []
      //   }
      //   return
      // }
      this.x = []
      this.y = []
      let i
      let unit = ''
      if (response.data.length === 0) {
        this.noData = true
      } else {
        this.noData = false
      }
      let minValue = Infinity
      for (i = 0; i < response.data.length; i++) {
        if (minValue > response.data[i].doc_count) {
          minValue = response.data[i].doc_count
        }
      }
      if (minValue > 1000) {
        unit = 'K'
      }
      if (this.fieldsum) {
        for (i = 0; i < response.data.length; i++) {
          this.x.push(response.data.map(a => a.sumbyte)[i].value)
          this.y.push(response.data[i].key)
          unit = this.orderby
        }
      } else {
        for (i = 0; i < response.data.length; i++) {
          this.x.push(response.data[i].doc_count)
          this.y.push(response.data[i].key)
        }
      }
      if (this.noData) {
        this.options = {
          title: {
            show: true,
            text: this.chartName,
            textStyle: {
              color: '#ccc',
              fontFamily: 'Avenir, Helvetica, Arial, sans-serif'
            }
          },
          backgroundColor: 'transparent',
          graphic: {
            type: 'text',
            left: 'center',
            top: 'middle',
            style: {
              text: 'No data',
              font: 'bolder 16px Avenir, Helvetica, Arial, sans-serif',
              fill: '#ccc'
            }
          },
          series: []
        }
      } else {
        this.options = {
          backgroundColor: 'transparent',
          title: {
            show: true,
            text: this.chartName,
            textStyle: {
              color: '#ccc',
              fontFamily: 'Avenir, Helvetica, Arial, sans-serif'
            }

          },
          grid: {
            top: 35,
            left: '5%',
            right: '8%',
            bottom: '5%',
            containLabel: true
          },
          tooltip: {
            trigger: 'item',
            formatter: this.host ? this.host : '{b}: {c} ({d}%)'
          },
          // toolbox: {
          //   show: true,
          //   orient: 'horizontal',
          //   itemSize: 18,
          //   itemGap: 20,
          //   right: 20,
          //   feature: {
          //     saveAsImage: {
          //       show: true,
          //       title: 'save as image'
          //     }
          //   }
          // },
          yAxis: [{
              type: 'category',
              data: this.y,
              inverse: true,
              axisTick: {
                alignWithLabel: true
              },
              axisLine: {
                lineStyle: {
                  color: 'white'
                }
              }
            }],
            xAxis: [{
              type: 'value',
              axisLabel: {
                rotate: 45,
                formatter: function formatBytes (params) {
                  if (unit === 'sumbyte') {
                    if (params === 0) return '0 Bytes'
                    const k = 1024
                    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
                    const i = Math.floor(Math.log(params) / Math.log(k))
                    return parseFloat((params / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
                  } else {
                    return params.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                  }
                }
              },
              axisTick: {
                show: false
              },
              axisLine: {
                lineStyle: {
                  color: 'white'
                }
              }
            }],
          series: [{
            name: 'count',
            type: 'bar',
            barWidth: '60%',
            data: this.x,
            animationDuration,
            itemStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(
                        0, 0, 0, 1,
                        [
                            {offset: 0, color: '#83bff6'},
                            {offset: 0.5, color: '#188df0'},
                            {offset: 1, color: '#188df0'}
                        ]
                      )
                  },
                    emphasis: {
                      label: {
                        show: true,
                        formatter: function formatBytes (params) {
                          if (unit === 'sumbyte') {
                            if (params.data === 0) return '0 Bytes'
                            const k = 1024
                            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
                            const i = Math.floor(Math.log(params.data) / Math.log(k))
                            return parseFloat((params.data / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
                          } else {
                            return params.data.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                          }
                        }
                      },
                        color: new echarts.graphic.LinearGradient(
                            0, 0, 0, 1,
                            [
                                {offset: 0, color: '#2378f7'},
                                {offset: 0.7, color: '#2378f7'},
                                {offset: 1, color: '#83bff6'}
                            ]
                        )
                    }
              }
          }]
        }
      }
    },
    beforeload () {
      this.$emit('loadChart', 'load', 'x-hbar')
    },
    clickupdatetime () {
      if (this.time === '') {
        console.log('This time is null')
      } else if (this.time !== '') {
        this.newtime = this.time
        if (this.startTime === 'now-1d') {
        this.times = this.time + 1800000
        this.intervals = '30s'
        } else if (this.startTime === 'now-15m') {
          this.times = this.time + 10000
          this.intervals = '1s'
        } else if (this.startTime === 'now-30m') {
          this.times = this.time + 30000
          this.intervals = '1s'
        } else if (this.startTime === 'now-1h') {
          this.times = this.time + 60000
          this.intervals = '1s'
        } else if (this.startTime === 'now-12h') {
          this.times = this.time + 1800000
          this.intervals = '30s'
        } else if (this.startTime === 'now-7d') {
          this.times = this.time + 10800000
          this.intervals = '600s'
        } else if (this.startTime === 'now-1M') {
          this.times = this.time + 43200000
          this.intervals = '600s'
        }
        this.$emit('setTime', this.newtime, this.times, this.intervals)
      }
    },
    handleChartClick (param) {
      this.startTime = this.startTime
      this.endTime = this.endTime
      this.key = param.name
      this.field = this.field
      this.$emit('setkey', this.startTime, this.endTime, this.key, this.field)
    },
    deleteChart () {
      this.$emit('deleteChart', this.chartId)
    },
    duplicateChart () {
      this.$emit('duplicateChart', this.slice)
    },
    action () {
      this.$emit('actionToChart')
    }
  },
  watch: {
    startTime: {
      handler: function (startTime) {
        if (!this.user_index) {
          this.user_index = this.index_now
        }
        this.options = {}
        this.initChart()
      }
    },
    endTime: {
      handler: function (endTime) {
        if (!this.user_index) {
          this.user_index = this.index_now
        }
        this.options = {}
        this.initChart()
      }
    },
    stores: {
      handler: function (stores) {
        if (!this.user_index) {
          this.user_index = this.index_now
        }
        this.options = {}
        this.initChart()
      }
    },
    text: {
      handler: function (text) {
        if (!this.user_index) {
          this.user_index = this.index_now
        }
        this.options = {}
        this.initChart()
      }
    },
    user_index: {
      handler: function (user_index) {
        if (this.user_index) {
          this.options = {}
          this.initChart()
        }
      }
    },
    index_now: {
      handler: function (user_index) {
        this.user_index = this.index_now
      }
    },
    reloadchart: {
      handler: function (val) {
        this.options = {}
        this.initChart()
      }
    }
  }
}
</script>

<style scoped>
/* .chart {
  min-height: 250px
} */
</style>



// WEBPACK FOOTER //
// src/components/x-hbar.vue